var Schema = require("lib/shared/Schema");
var CustomersAPIClient = require("lib/web/CustomersAPIClient");
var ActionUtility = require("lib/shared/ActionUtility");
var Queries = require("lib/shared/Queries");

////////////////////////////////////////
// Contacts ////////////////////////////
////////////////////////////////////////


export function fetchContact({ id, embeds, query }) {
	var params = _.extend({}, query);
	return (dispatch) => {
		return dispatch(ActionUtility.fetchRecord(
			CustomersAPIClient.getContact,
			id,
			{ contact: Schema.CONTACT },
			{ embeds, params },
			{ reducer: "contacts", loading: id }));
	}
}

export function updateContact({ id, update, embeds, query }) {
	var params = _.extend({}, query, { contact: update });

	return (dispatch) => {
		dispatch({ type: ActionUtility.UPDATE_RECORDS, contacts: [id], update: update });
		return dispatch(ActionUtility.fetchRecords(
			CustomersAPIClient.patchContact.bind(null, id),
			{ contact: Schema.CONTACT },
			{ params, embeds },
			{ reducer: "contacts", loading: id }
		))
	}
}

export function createContact({ contact, embeds, query }) {
	var params = _.extend({}, query, { contact: contact });

	return (dispatch) => {

		return dispatch(ActionUtility.fetchRecords(
			CustomersAPIClient.postContacts,
			{ contact: Schema.CONTACT },
			{ embeds, params, query },
			{ reducer: "contacts", loading: "create" }
		))		
	}
}

////////////////////////////////////////
// Deals ///////////////////////////////
////////////////////////////////////////

export function fetchDeal({ id, embeds }) {
	return (dispatch) => {
		return dispatch(ActionUtility.fetchRecord(
			CustomersAPIClient.getDeal,
			id,
			{ deal: Schema.DEAL },
			{ embeds },
			{ reducer: "deals", loading: id }));
	}
}

export function createDeal({ deal, nextTasks, embeds, query }) {
	var params = _.extend({}, query, { deal: deal });
	if (nextTasks) {
		params.next_tasks = nextTasks;
	}

	return (dispatch) => {

		return dispatch(ActionUtility.fetchRecords(
			CustomersAPIClient.postDeals,
			{ deal: Schema.DEAL },
			{ embeds, params, query },
			{ reducer: "deals", loading: "create" }
		))		
	}
}


export function updateDeal({ id, update, files, nextTasks, newContacts, embeds, query }) {
	var params = _.extend({}, query, { deal: update });
	if (nextTasks) {
		params.next_tasks = nextTasks;
	}
	if (newContacts) {
		params.new_contacts = newContacts;
	}
	if (files) {
		params.files = files;
	}

	return (dispatch) => {
		dispatch({ type: ActionUtility.UPDATE_RECORDS, deals: [id], update: update });
		return dispatch(ActionUtility.fetchRecords(
			CustomersAPIClient.patchDeal.bind(null, id),
			{ deal: Schema.DEAL },
			{ params, embeds },
			{ reducer: "deals", loading: id }
		))
	}
}

////////////////////////////////////////
// Estimates ///////////////////////////
////////////////////////////////////////

export function createEstimates({ estimates, customer, embeds, query }) {
	var params = _.extend({}, query, { estimates, customer });

	return (dispatch) => {
		return dispatch(ActionUtility.fetchRecords(
			CustomersAPIClient.postEstimates,
			{ estimates: [Schema.ESTIMATE] },
			{ embeds, params },
			{ reducer: "estimates", loading: "create" }
		))
	}
}

export function fetchEstimates({ query, embeds }) {
	var params = _.extend({}, query);

	return (dispatch) => {
		return dispatch(ActionUtility.fetchRecords(
			CustomersAPIClient.getEstimates,
			{ estimates: [Schema.ESTIMATE] },
			{ embeds, params },
			{ reducer: "estimates", loading: "create" }
		))
	}
}

////////////////////////////////////////
// Invoices ////////////////////////////
////////////////////////////////////////

export function createInvoice({ invoice, embeds, query }) {
	var params = _.extend({}, query, { invoice: invoice });

	return (dispatch) => {

		return dispatch(ActionUtility.fetchRecords(
			CustomersAPIClient.postInvoices,
			{ invoice: Schema.INVOICE },
			{ embeds, params, query },
			{ reducer: "invoices", loading: "create" }
		))		
	}
}

export function updateInvoice({ id, update, embeds, query }) {
	// NOTE! ID might actually be Invoice No., not the id used in redux

	var params = _.extend({}, query, { invoice: update });

	return (dispatch) => {
		return dispatch(ActionUtility.fetchRecords(
			CustomersAPIClient.patchInvoice.bind(null, id),
			{ invoice: Schema.INVOICE },
			{ params, embeds },
			{ reducer: "invoices", loading: id }
		))
	}
}





// WEBPACK FOOTER //
// ./modules/lib/actions/CRMActions.js